/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class OrgsService implements IOrgsService {
    public static $inject = ['$http', 'Api', '$q'];

    private orgs = {
        last_update: undefined,
        info: undefined
    };

    public defer;

    constructor (private $http: ng.IHttpService,
                 private Api: Restangular.IService,
                 private $q: any) {
                   var that = this
                    Api.addResponseInterceptor(function(data, operation, what, url, response, deferred) {
                      if (url == "/api/org" && response.status === 200 && (operation == "get" || operation == "put" || operation == "patch" || operation == "post")){
                         that.orgs.info = data;
                         that.orgs.last_update = moment();
                      }
                      return data
                    });

    }


    public getMyOrg(): Restangular.IPromise<any> {
        return this.Api.oneUrl('org', '/api/org').get();
    }

    public getOrg(id: any): Restangular.IPromise<any> {
        if (id) {
            return this.Api.one('orgs', id).get()
        } else {
            return this.Api.oneUrl('org', '/api/org').get()
        }
    }
    
    public getOrgs(): Restangular.IPromise<any> {
        return this.Api.all('orgs').getList();
    }

    public getArchivedOrg(id: any): Restangular.IPromise<any> {
        if (id) {
            return this.Api.one('orgs_archived', id).get()
        } else {
            return this.Api.oneUrl('org', '/api/org').get()
        }
    }

    public deleteOrg(id: any): void {           
        this.$http.delete('/api/org/'+id)/*.then((responses) => {
            let responseData: any = responses.data;           
        }*/
    }

    public getArchivedOrgs(): Restangular.IPromise<any> {
        return this.Api.all('orgs_archived').getList();
    }

    public getWizardStatus(): Restangular.IPromise<any> {
        return this.Api.all('wizard_status').getList();
    }

    public loadSchema(): angular.IPromise<any> {
        return this.$http.get('/static/schemas/org.schema.json');
    }


    public getTitlesBySchema(schema: any, parent: string, res: any): string[] {
        if (schema.type && schema.type === 'object') {
            this.getTitlesBySchema(schema.properties, parent, res);
        } else if (schema.type && schema.type === 'array') {
            this.getTitlesBySchema(schema.items, parent, res);
        } else if (!schema.type) {
            _.forEach(schema, (elem: any, key: string) => {
                if (elem.type && elem.type !== 'object' && elem.type !== 'array') {
                    if (parent.length !== 0) {
                        res[`${parent}__${key}`] = elem.title || key;
                    } else {
                        res[key] = elem.title || key;
                    }
                } else {
                    this.getTitlesBySchema(schema[key], key, res);
                }
            });
        }
        return res;
    }

    /**
     * Service return list of documents from cache or do new request and put result in chache
     * You can set a cache time for this
     * @param fn
     */
    public getOrgFromCache(fn): void {
        const CACHE_TIME = 30; // in seconds

        // If we have cached files and cache valid (by time) then we return files
        if (this.orgs.info &&
            (this.orgs.last_update && -this.orgs.last_update.diff(moment(), 'seconds') < CACHE_TIME)
        ) {
            (fn || angular.noop)(this.orgs.info);
        } else {
            // If cache lifetime expires then we send new request
            if (this.orgs.last_update && -this.orgs.last_update.diff(moment(), 'seconds') > CACHE_TIME && this.defer) {
                this.defer = false;
            }

            // check if we have a promised, then wait promise resolve and return file
            if (this.defer) {
                this.defer.promise.then(() => {
                    (fn || angular.noop)(this.orgs.info);
                })
            } else {
                // set cache time
                this.orgs.last_update = moment();
                // create new promise
                this.defer = this.$q.defer();
                // send response
                this.getMyOrg().then((response) => {
                    this.orgs.info = response;

                    this.orgs.last_update = moment();

                    this.defer.resolve();

                    (fn || angular.noop)(this.orgs.info);
                })
            }
        }
    }

    /*
    *   The new service function for the inline Editing
    *   Still need to  be modified;
    */ 

    public inlineUpdateInformation(organisationInLineInfo: any): Restangular.IPromise<any>{
        //returning temporary information from anywhere for testing - this is overwritten in the controller
        //replace below with new api call
        return this.Api.one('employees').get({'': '1'});
   }

    public deleteDocs(delObj: any): void {
        delObj = {

        };
    }

   public createOrgClone(orgInfo: any): Restangular.IPromise<any> {
        return this.Api.one('employees').get({'': '1'});

        //return this.Api.one('').get('');
   }

}


angular.module('beneple.global')
    .service('Orgs', OrgsService);



// WEBPACK FOOTER //
// ./frontend/scripts/organisation/services/orgs.services.ts